import React from "react";
import PropTypes from "prop-types";

const primaryButtonStyle = {
    border: "none",
    background: "#2563eb",
    color: "#ffffff",
    padding: "12px 22px",
    borderRadius: "10px",
    fontWeight: 600,
    fontSize: "14px",
    cursor: "pointer",
    transition: "all 0.25s ease",
};

const secondaryButtonStyle = {
    border: "1px solid #d1d5db",
    background: "#ffffff",
    color: "#1e293b",
    padding: "11px 20px",
    borderRadius: "10px",
    fontWeight: 600,
    fontSize: "14px",
    cursor: "pointer",
    transition: "all 0.25s ease",
};

const PageHeader = ({
    title,
    subtitle,
    actions = [],
}) => {
    const handleMouseEnter = (event, variant) => {
        if (variant === "secondary") {
            event.currentTarget.style.background = "#f8fafc";
            return;
        }

        event.currentTarget.style.background = "#1d4ed8";
        event.currentTarget.style.transform = "translateY(-2px)";
    };

    const handleMouseLeave = (event, variant) => {
        if (variant === "secondary") {
            event.currentTarget.style.background = "#ffffff";
            return;
        }

        event.currentTarget.style.background = "#2563eb";
        event.currentTarget.style.transform = "translateY(0)";
    };

    return (
        <div
            style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                flexWrap: "wrap",
                gap: "20px",
                marginBottom: "24px",
            }}
        >
            <div>
                <h1
                    style={{
                        margin: 0,
                        fontSize: "32px",
                        fontWeight: 600,
                        color: "#1e293b",
                    }}
                >
                    {title}
                </h1>

                {subtitle && (
                    <p
                        style={{
                            marginTop: "8px",
                            marginBottom: 0,
                            color: "#64748b",
                            fontSize: "15px",
                        }}
                    >
                        {subtitle}
                    </p>
                )}
            </div>

            {actions.length > 0 && (
                <div
                    style={{
                        display: "flex",
                        gap: "10px",
                        flexWrap: "wrap",
                    }}
                >
                    {actions.map((action, index) => {
                        const variant =
                            action.variant === "secondary"
                                ? "secondary"
                                : "primary";

                        return (
                            <button
                                key={index}
                                type="button"
                                onClick={action.onClick}
                                disabled={action.disabled}
                                style={
                                    variant === "secondary"
                                        ? secondaryButtonStyle
                                        : primaryButtonStyle
                                }
                                onMouseEnter={(event) =>
                                    handleMouseEnter(event, variant)
                                }
                                onMouseLeave={(event) =>
                                    handleMouseLeave(event, variant)
                                }
                            >
                                {action.icon && (
                                    <span
                                        style={{
                                            marginRight: "8px",
                                        }}
                                    >
                                        {action.icon}
                                    </span>
                                )}

                                {action.label}
                            </button>
                        );
                    })}
                </div>
            )}
        </div>
    );
};

PageHeader.propTypes = {
    title: PropTypes.string.isRequired,

    subtitle: PropTypes.string,

    actions: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string.isRequired,
            icon: PropTypes.node,
            variant: PropTypes.oneOf([
                "primary",
                "secondary",
            ]),
            disabled: PropTypes.bool,
            onClick: PropTypes.func,
        })
    ),
};

export default PageHeader;
